import { NamiCampaign, NamiInitialConfig } from "@namiml/web-sdk";
import { testPaywallFiles } from '../data/test-paywalls';

type FullInitialConfig = Exclude<NamiInitialConfig, { initial_config: string }>;
type NamiPaywalls = FullInitialConfig['paywalls'];
type NamiPaywall = NonNullable<NamiPaywalls>[number];

const API_CAMPAIGN_RULES = "api_campaign_rules";
const API_PAYWALLS = "api_paywalls";

function simpleUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : ((r & 0x3) | 0x8);
    return v.toString(16);
  });
}

export function augmentStoredData() {
  const campaigns = JSON.parse(localStorage.getItem(API_CAMPAIGN_RULES) ?? '[]');
  const paywalls = JSON.parse(localStorage.getItem(API_PAYWALLS) ?? '[]');

  const campaignValues = new Set(campaigns.map((campaign: NamiCampaign) => campaign.value));
  const newCampaigns = createCampaigns(testPaywallFiles);
  for (const newCampaign of newCampaigns) {
    if (!campaignValues.has(newCampaign.value)) {
      campaigns.push(newCampaign);
    }
  }
  localStorage.setItem(API_CAMPAIGN_RULES, JSON.stringify(campaigns));

  const paywallIds = new Set(paywalls.map((paywall: NamiPaywall) => paywall.id));
  for (const paywall of Object.values(testPaywallFiles)) {
    if (!paywallIds.has(paywall.id)) {
      paywalls.push(paywall);
    }
  }
  localStorage.setItem(API_PAYWALLS, JSON.stringify(paywalls));
}

function createCampaigns(paywallFiles: Record<string, NamiPaywall>): NamiCampaign[] {
  return Object.values(paywallFiles).map(file => ({
    rule: simpleUUID(),
    name: file.name,
    segment: file.id,
    paywall: file.id,
    type: 'label',
    value: file.name,
    external_segment: null,
    form_factors: [
        {
            "form_factor": "phone",
            "supports_portrait": true,
            "supports_landscape": false
        },
        {
            "form_factor": "tablet",
            "supports_portrait": true,
            "supports_landscape": true
        },
        {
            "form_factor": "desktop",
            "supports_portrait": true,
            "supports_landscape": true
        },
        {
            "form_factor": "television",
            "supports_portrait": false,
            "supports_landscape": true
        }
    ],
  }));
}
